import { render, staticRenderFns } from "./CreateNoiseBlock.vue?vue&type=template&id=bfd1841a&scoped=true"
import script from "./CreateNoiseBlock.vue?vue&type=script&lang=js"
export * from "./CreateNoiseBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd1841a",
  null
  
)

export default component.exports